import {combineReducers} from "redux";
import places from "./places";
import itinerary from "./itinerary";
import path from "./path";
import suggestionList from "./suggestions";
import profile from "./profile";

export default combineReducers({
    places,
    itinerary,
    path,
    suggestionList,
    profile
})
